import React from 'react';
import VariableForm from './VariableForm';

class PartForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.data.id,
            partNum: props.data.partNum,
            name: props.data.name,
            designType: props.data.designType,
            repetitionCount: props.data.repetitionCount,
            description: props.data.description,
            variables: props.data.variables,
            varKeyCount: props.data.variables.length
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAddVariable = this.handleAddVariable.bind(this);
        this.sendDataToParent = this.sendDataToParent.bind(this);
        this.updateVariableValues = this.updateVariableValues.bind(this);
        this.removeSelf = this.removeSelf.bind(this);
        this.removeVariable = this.removeVariable.bind(this);
    }

    removeVariable = (id) => {
        this.setState({variables: this.state.variables.filter(function(variable) {
            return variable.varNum !== id
        })}, () => { this.sendDataToParent(); });
    }

    removeSelf(){
        this.props.handleRemove(this.state.partNum);
    }

    sendDataToParent(){
        this.props.handleUpdate(this.state);
    }

    handleInputChange = (e) => {
        if (e.target.name === "name") {
            this.setState({ name: e.target.value},
                () => { this.sendDataToParent(); }
            );
        }
        else if (e.target.name === "repetitionCount") {
            this.setState({ repetitionCount: e.target.value},
                () => { this.sendDataToParent(); }
            );
        }
        else if (e.target.name === "description") {
            this.setState({ description: e.target.value},
                () => { this.sendDataToParent(); }
            );
        }
    };

    updateVariableValues = (varData) => {
        var existingVars = this.state.variables;
        var index = existingVars.findIndex( (variable) => variable.varNum === varData.varNum);
        existingVars[index] = varData;
        this.setState({ variables: existingVars}, () => { this.sendDataToParent() });
    }

    handleAddVariable(){
        var existingVars = this.state.variables;
        existingVars.push({varNum: this.state.varKeyCount,
                           name: "",
                           positiveValue: "",
                           calculationMethod: "NORMAL_DISTRIBUTION",
                           dataType: "DOUBLE",
                           variables: []});
        this.setState({ variables: existingVars, varKeyCount: (this.state.varKeyCount +1)}, () => { this.sendDataToParent() });
    }

    render() {
        var renderedVariables = [];
        if (typeof this.state.variables !==  "undefined"){
            for (var i = 0; i < this.state.variables.length; i++) {
                renderedVariables.push( <VariableForm key={this.state.variables[i].varNum}
                                            handleUpdate={this.updateVariableValues}
                                            handleRemove={this.removeVariable}
                                            data={this.state.variables[i]} /> );
            }
        }

        return (
        <>
            <div className="partTable" style={{paddingLeft: "20px", paddingRight: "20px", paddingBottom: "20px", paddingTop: "10px",
                        marginBottom: "20px", backgroundColor: "#F0F0F0"}}>
                <table style={{width: "100%"}}>
                    <tbody>
                        <tr>
                            <td style={{ width: "30%"}}>
                                <div className="form-group">
                                    <label>Name</label>
                                    <input className="form-control nameField" type="text" name="name" placeholder="Part name"
                                    value={this.state.name}
                                    onChange={(e) => this.handleInputChange(e)} />
                                </div>
                                <div className="form-group">
                                    <label>Design type</label>
                                    <select className="form-control" name="designType" disabled/>
                                </div>
                                <div className="form-group">
                                    <label>Repetition count</label>
                                    <input className="form-control" type="text" name="repetitionCount"
                                    value={this.state.repetitionCount}
                                    onChange={(e) => this.handleInputChange(e)} />
                                </div>
                            </td>
                            <td style={{ paddingLeft: "20px", verticalAlign: "top"}}>
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea className="form-control" name="description" placeholder="Description"
                                    value={this.state.description}
                                    onChange={(e) => this.handleInputChange(e)} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h2>Variables</h2>
                <div className="alert alert-warning" style={{textAlign: "center" }} hidden={this.state.variables.length > 0}>
                  <strong>No variables data</strong>
                </div>

                <div style={{display: "flex", flexWrap: "wrap"}}>{renderedVariables}</div>

                <button style={{marginRight: "20px"}} type="button"
                    id="newVariableButton" className="btn btn-default" onClick={this.handleAddVariable} >
                    New Variable
                </button>

                <button type="button"
                    id="removePartButton" className="btn btn-danger" onClick={this.removeSelf} >
                    Remove part
                </button>
            </div>
        </>
        );
    }
}

export default PartForm;